import { render, staticRenderFns } from "./SepultamentoSV.vue?vue&type=template&id=195ade52&scoped=true&"
import script from "./SepultamentoSV.vue?vue&type=script&lang=js&"
export * from "./SepultamentoSV.vue?vue&type=script&lang=js&"
import style0 from "./SepultamentoSV.vue?vue&type=style&index=0&id=195ade52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ade52",
  null
  
)

export default component.exports